'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../../01.atoms/Icon/Icon.js');
var Expandable = require('../../01.atoms/Expandable/Expandable.js');
var RichText = require('../../01.atoms/RichText/RichText.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-accordion',
    cnExpanded = "".concat(CLASSNAME, "--expanded"),
    cnBody = "".concat(CLASSNAME, "__body"),
    cnWrapperTitle = "".concat(CLASSNAME, "__wrapper-title"),
    cnNumber = "".concat(CLASSNAME, "__number"),
    cnTitle = "".concat(CLASSNAME, "__title"),
    cnWrapperInner = "".concat(CLASSNAME, "__wrapper-inner"),
    cnButton = "".concat(CLASSNAME, "__button"),
    cnIcon = "".concat(CLASSNAME, "__icon"),
    cnRichText = "".concat(CLASSNAME, "__rich-text"),
    cnRichTextOrdered = "".concat(cnRichText, "--ordered");
/**
 * 
 */

var Accordion = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(Accordion, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(Accordion);

  function Accordion() {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, Accordion);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "state", {
      expanded: []
    });

    return _this;
  }

  _rollupPluginBabelHelpers.createClass(Accordion, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var expanded = this.state.expanded;
      var items = this.props.items;
      return nextState.expanded !== expanded || nextProps.items !== items;
    }
  }, {
    key: "toggleExpandState",
    value: function toggleExpandState(index) {
      this.setState(function (state) {
        var expanded = _rollupPluginBabelHelpers.toConsumableArray(state.expanded);

        expanded[index] = !expanded[index];
        return _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, state), {}, {
          expanded: expanded
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          iconExpanded = _this$props.iconExpanded,
          iconCollapsed = _this$props.iconCollapsed,
          items = _this$props.items,
          ordered = _this$props.ordered,
          style = _this$props.style,
          expanded = this.state.expanded,
          classes = [CLASSNAME, className];
      return /*#__PURE__*/React__default.createElement("div", {
        className: classNames(classes, _rollupPluginBabelHelpers.defineProperty({}, "".concat(CLASSNAME, "--").concat(style), style))
      }, items.map(function (item, i) {
        var icon = expanded[i] ? iconExpanded : iconCollapsed;
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
          className: classNames(cnWrapperTitle, _rollupPluginBabelHelpers.defineProperty({}, cnExpanded, expanded[i])),
          onClick: function onClick() {
            return _this2.toggleExpandState(i);
          }
        }, ordered && /*#__PURE__*/React__default.createElement("div", {
          className: cnNumber
        }, i + 1, "."), /*#__PURE__*/React__default.createElement("div", {
          className: cnTitle
        }, item.title), /*#__PURE__*/React__default.createElement("button", {
          className: cnButton,
          role: "button",
          "aria-label": "Expand Text"
        }, /*#__PURE__*/React__default.createElement(Icon, {
          className: cnIcon,
          id: icon,
          size: "sm"
        }))), /*#__PURE__*/React__default.createElement(Expandable, {
          className: cnBody,
          classNameContent: cnWrapperInner,
          expanded: expanded[i],
          onMount: _this2.onExpandableMount,
          overlay: false
        }, typeof item.content === 'string' ? /*#__PURE__*/React__default.createElement(RichText, {
          content: item.content,
          className: classNames(cnRichText, _rollupPluginBabelHelpers.defineProperty({}, cnRichTextOrdered, ordered))
        }) : item.content));
      }));
    }
  }]);

  return Accordion;
}(React__default.Component);
Accordion.propTypes = {
  /** Additional class name */
  className: PropTypes.string,

  /** Custom icon for when Accordion is collapsed */
  iconCollapsed: PropTypes.string,

  /** Custom icon for when Accordion is expanded */
  iconExpanded: PropTypes.string,

  /** Items array to be rendered as multiple Accordions */
  items: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    content: PropTypes.oneOfType([PropTypes.node, PropTypes.string])
  })).isRequired,

  /** */
  ordered: PropTypes.bool,

  /** */
  style: PropTypes.oneOf(['light', 'dark'])
};
Accordion.defaultProps = {
  iconCollapsed: 'caret-down',
  iconExpanded: 'times-small',
  items: []
};

module.exports = Accordion;
